import {
    IGroupEntityDTO,
    ISortedItemIdNameType,
    ITemplateGroupEntityDTO,
    ITemplateGroupItemEntityDTO,
    SortedTemplateItem,
} from '@modeso/types__aumico-lib-templates-be';

export class TemplateGroup implements ITemplateGroupEntityDTO {
    groupRef: IGroupEntityDTO;
    groups: ITemplateGroupEntityDTO[];
    items: ITemplateGroupItemEntityDTO[];
    sortedItems?: SortedTemplateItem[] | ISortedItemIdNameType[];
    constructor(groupRef: IGroupEntityDTO) {
        this.groupRef = groupRef;
        this.groups = [];
        this.items = [];
        this.sortedItems = [];
    }
}
